<template>
<div class="member-tag">
    <div class="member-container">
      <div class="member-name">{{ data.memberName }}</div>
      <div
        class="delete-img"
        @mouseenter.stop="deleteIconHover(true)"
        @mouseleave.stop="deleteIconHover(false)"
      >
        <svg-icon
          :icon-class="iconClass"
          class="delete-icon"
          @click.stop="deleteMember(data)"
        ></svg-icon>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MemberTag",
  props: {
    data: {
      type: Object,
    },
  },
  data() {
    return {
      isHover: false,
      iconClass: "file-transfer-delete-no-hover",
    };
  },
  methods: {
    deleteMember(data) {
      this.$emit("deleteMember", data);
    },
    deleteIconHover(isHover) {
      if (isHover) {
        this.iconClass = "file-transfer-delete";
      } else {
        this.iconClass = "file-transfer-delete-no-hover";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.member-tag {
  height: 24px;
  background: #ffffff;
  border-radius: 4px;
  text-align: center;
  margin-left: 12px;

  .member-container {
    padding: 2px 6px;
    display: flex;
    align-items: center;
    justify-content: center;

    .member-name {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #121317;
      line-height: 20px;
      margin-right: 4px;
    }

    .delete-img {
      display: flex;
      align-items: center;
      justify-content: center;

      .delete-icon {
        width: 10px;
        height: 10px;
        cursor: pointer;
      }
    }
  }
}
</style>
